import { useMemo } from 'react';

import { EventTriggerType, Trigger } from '../../domain';
import { OrderlyRevenueType, OrderlyVolumeType } from '../../types';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export default function OrderlyTriggerDetails({ trigger, triggerType }: Props) {
  const volumeTypeDisplay = useMemo(() => {
    const volumeType = trigger.context?.volumeType as OrderlyVolumeType;

    const volumeTypeLabels: Record<OrderlyVolumeType, string> = {
      [OrderlyVolumeType.AllVolume]: 'All Volume',
      [OrderlyVolumeType.TakerVolume]: 'Taker Volume',
      [OrderlyVolumeType.MakerVolume]: 'Maker Volume',
    };

    return volumeTypeLabels[volumeType] || volumeType || 'N/A';
  }, [trigger.context?.volumeType]);

  const revenueTypeDisplay = useMemo(() => {
    const revenueType = trigger.context?.revenueType as OrderlyRevenueType;

    const revenueTypeLabels: Record<OrderlyRevenueType, string> = {
      [OrderlyRevenueType.TotalFee]: 'Total Fee',
      [OrderlyRevenueType.BrokerFee]: 'Broker Fee',
      [OrderlyRevenueType.RealizedPnl]: 'Realized PnL',
    };

    return revenueTypeLabels[revenueType] || revenueType || 'N/A';
  }, [trigger.context?.revenueType]);

  const brokerId = useMemo(() => {
    return trigger.context?.brokerId || 'N/A';
  }, [trigger.context?.brokerId]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerValueDetail label="Volume Type" value={volumeTypeDisplay} />
      <TriggerValueDetail label="Revenue Type" value={revenueTypeDisplay} />
      <TriggerValueDetail label="Broker ID" value={brokerId} />
    </div>
  );
}
